import { render, staticRenderFns } from "./NEUT.vue?vue&type=template&id=b2f7167c&scoped=true"
import script from "./NEUT.vue?vue&type=script&lang=js"
export * from "./NEUT.vue?vue&type=script&lang=js"
import style0 from "./NEUT.vue?vue&type=style&index=0&id=b2f7167c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f7167c",
  null
  
)

export default component.exports